import React, { useState, useEffect } from 'react';
import window from './window_wrapper';
import { mParticleReady } from '@reverbdotcom/commons/src/elog/mparticle';

export interface MpidProps {
  mpid?: string;
}

export function withMpid<TProps>(
  WrappedComponent: React.ComponentType<TProps>,
) {
  return (props: TProps) => {
    const [mpid, setMpid] = useState('');

    useEffect(
      () => {
        if (mpid) {
          return;
        }

        mParticleReady(() => {
          setMpid(
            window.mParticle.Identity.getCurrentUser?.()?.getMPID(),
          );
        });
      },
      [],
    );

    return (
      <WrappedComponent
        {...props}
        mpid={mpid}
      />
    );
  };
}
